<!--
Copyright 2025 Google Inc. All rights reserved.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->

<!-- modified for WISPR-lab/data-export-gui -->

<template>
  <div
    v-if="iconOnly"
    class="pa-4"
    style="cursor: pointer"
    @click="navigateToDevices"
  >
    <v-icon :color="isActive ? 'primary' : ''">mdi-devices</v-icon>
  </div>
  <div v-else id="tsNavigationDevices">
    <v-divider class="mb-0"></v-divider>
    <div
      class="pa-4"
      style="cursor: pointer"
      @click="navigateToDevices"
      :class="[
        $vuetify.theme.dark ? 'dark-hover' : 'light-hover',
        isActive ? 'active-view' : ''
      ]"
    >
      <span> <v-icon left :color="isActive ? 'primary' : ''">mdi-devices</v-icon> Devices </span>
    </div>
  </div>
</template>

<script>
import EventBus from '@/event-bus.js'

export default {
  props: {
    iconOnly: Boolean,
  },
  computed: {
    isActive() {
      return this.$route.name === 'Devices' || this.$route.name === 'DevicesMockup' || this.$route.name === 'DemoDevices'
    }
  },
  methods: {
    navigateToDevices() {
      const target = this.$store.state.demoMode ? '/demo/devices' : '/devices'
      if (this.$route.path !== target) {
        this.$router.push(target)
      }
      if (this.$store.state.demoMode) {
        EventBus.$emit('demo:action', 'route-changed-devices')
      }
    },
  },
}
</script>

